import { render } from "./ProsesKategoriData.vue?vue&type=template&id=37a114e0"
import script from "./ProsesKategoriData.vue?vue&type=script&lang=js"
export * from "./ProsesKategoriData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__